import {
  isEmptyString,
} from '@populateui/utils';
import {
  FormFieldView,
} from 'dtos';
import {
  FieldType,
} from 'views/EMR/components/FillableForm/types';

export default function getFieldTypeByField(field: FormFieldView): FieldType {
  let fieldType = (field?.type ?? 'shortText') as FieldType;

  if (fieldType === 'shortText' && !isEmptyString(field?.name)) {
    if (/ssn/i.test(field?.format ?? '')) {
      fieldType = 'ssn';
    } else if (/ein/i.test(field?.format ?? '')) {
      fieldType = 'ein';
    }
  }
  return fieldType as FieldType;
}
